/* eslint-disable react/no-array-index-key */
import React, {
  //   lazy,
  // Suspense,
} from "react";
import { Redirect, Route, matchPath, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
import AllRoutes from "./routes/index.routes";
import Home from "./views/Home";
import Login from "./views/connect/Login";
import MaintenancePage from "./views/connect/MaintenancePage.js"
import Topmenu from "./layouts/topmenu/topmenu";
import Header from "./layouts/header/header";
import SectionNavigation from "./layouts/sectionNavigation/SectionNavigation";
import Footer from "./layouts/footer/footer";
import InfosFooter from "./layouts/infosfooter/infosfooter";
import Breadcrumb from "./layouts/breadcrumb/breadcrumb";
import Categories from "./views/categories/Categories";
import SimulateurMain from "./views/simulateurs/SimulateurMain";
import DmtgMain from "./views/dmtg/DmtgMain";
import OthersMain from "./views/others/OthersMain";
import Profile from "./views/user/Profile";
import Avis from "./views/informations/avis";
import Fiches from "./views/informations/fiches";
// import FichesImmo from "./views/informations/fiches_immo";
// import FichesFamille from "./views/informations/fiches_famille";
// import FichesGenerales from "./views/informations/fiches_generales";
// import Rappels from "./views/informations/rappels";
import Pratiques from "./views/informations/pratiques";
import SchemaFiscalite from "./views/patrimoine/SchemaFiscalite";
import ESSENTIEL from "./views/essentiel/tarif_des_notaires";
import ProcessPatrimoine from "./views/patrimoine/processPatrimoine.js"
import ForgotPassword from "./views/ForgotPassword/ForgotPassword";
import MenuPatrimoine from "./views/patrimoine/menuPatrimoine.js";
import FramedPDF from "./views/FramedPDF";
import EssentielTracker from "./components/GoogleAnalytics/essentel_hit.js";
import LoyiaMain from "./views/loyia/LoyiaMain";
import Favoris from "./views/favoris/Favoris";
import NotFound from "./views/NotFound/NotFound";

const EmptyRouteSlot = () => null;
const RedirectToLogin = () => <Redirect to="/login" />;

const routesConfig = [
  {
    exact: true,
    path: "/maintenance",
    component: MaintenancePage,
  },
  {
    exact: true,
    path: "/",
    component: () => null,
  },
  {
    exact: true,
    path: "/login",
    component: (props) => (checkJWT() ? <Redirect to="/" /> : <Login {...props} />),
    layoutFooter: Footer,
  },
  {
    exact: true,
    path: "/categorie",
    component: () => <Redirect to="/" />,
  },
  {
    exact: true,
    path: "/categorie/:url_name/simulateur",
    component: () => <Redirect to="/categorie/:url_name" />,
  },
  {
    exact: true,
    path: "/categorie/:url_name#:id",
    component: () => <Redirect to="/categorie/:url_name" />,
  },
  {
    exact: true,
    path: "/simulateur",
    component: () => <Redirect to="/" />,
  },
  {
    exact: true,
    path: "/moncompte",
    component: () => <Redirect to="/moncompte" />,
  },
  {
    exact: true,
    path: "/fiches/fiches_immo",
    component: () => <Redirect to="/fiches/fiches_immo" />,
  },
  {
    exact: true,
    path: "/fiches/fiches_famille",
    component: () => <Redirect to="/fiches/fiches_famille" />,
  },
  {
    exact: true,
    path: "/fiches/fiches_generales",
    component: () => <Redirect to="/fiches/fiches_generales" />,
  },
  {
    exact: true,
    path: "/SchemaFiscalite",
    component: () => <Redirect to="/SchemaFiscalite" />,
  },
  {
    exact: true,
    path: "/AnalysePatrimoniale/ProcessPatrimoine#:id",
    component: () => <Redirect to="/AnalysePatrimoniale/ProcessPatrimoine/:id" />,
  },
  {
    exact: true,
    path: "/AnalysePatrimoniale",
    component: () => <Redirect to="/AnalysePatrimoniale" />,
  },
  {
    exact: true,
    path: "/FramedPDF#:url",
    component: () => <Redirect to="/FramedPDF/:url" />,
  },
  // {
  //     exact: true,
  //     path: '/404',
  //     component: lazy(() => import('src/views/pages/Error404View'))
  // },
  AllRoutes,
  {
    path: "/",
    authOnly: true,
    layoutInfoFooter: InfosFooter,
    layoutFooter: Footer,
    routes: [
      {
        exact: true,
        path: "/",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) =>
          checkJWT() ? <Home {...props} /> : <Redirect to="/login" />,
      },
      {
        exact: true,
        path: "/tarif_des_notaires",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <ESSENTIEL {...props} /> : <Redirect to="/tarif_des_notaires" />),
      },
      {
        exact: true,
        path: "/moncompte",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Profile {...props} /> : <Redirect to="/moncompte" />),
      },
      {
        exact: true,
        path: "/favoris",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Favoris {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/categorie/:url_name",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Categories {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/categorie/:url_name/simulateur/:simulateur",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) =>
          checkJWT() ? <SimulateurMain {...props} /> : <Redirect to="/login" />,
      },
      {
        exact: true,
        path: "/categorie/:url_name/dmtg/:simulateur",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <DmtgMain {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/categorie/:url_name/others/:simulateur",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <OthersMain {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/avis",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Avis {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/fiches",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Fiches {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/pratique",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <Pratiques {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/pratiques",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: () => <Redirect to="/pratique" />,
      },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_immo",
      //   layout: Topmenu,
      //   layoutHeader: Header,
      //   component: () => (checkJWT() ? FichesImmo : <Redirect to="/login" />),
      // },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_famille",
      //   layout: Topmenu,
      //   layoutHeader: Header,
      //   component: () =>
      //     checkJWT() ? FichesFamille : <Redirect to="/login" />,
      // },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_generales",
      //   layout: Topmenu,
      //   layoutHeader: Header,
      //   component: () =>
      //     checkJWT() ? FichesGenerales : <Redirect to="/login" />,
      // },
      // {
      //   exact: true,
      //   path: "/rappels",
      //   layout: Topmenu,
      //   layoutHeader: Header,
      //   layoutBreadCrumb: Breadcrumb,
      //   component: () => (checkJWT() ? Rappels : <Redirect to="/login" />),
      // },
      {
        exact: true,
        path: "/SchemaFiscalite",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        layoutBreadCrumb: Breadcrumb,
        component: (props) => (checkJWT() ? <SchemaFiscalite {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/AnalysePatrimoniale/ProcessPatrimoine/:id",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <ProcessPatrimoine {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/AnalysePatrimoniale",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <MenuPatrimoine {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/FramedPDF/:url",
        component: (props) => (checkJWT() ? <FramedPDF {...props} /> : <Redirect to="/login" />),
      },
      {
        exact: true,
        path: "/loyia",
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        component: (props) => (checkJWT() ? <LoyiaMain {...props} /> : <Redirect to="/login" />),
      },
      // {
      //     component: () => <Redirect to="/404"/>
      // }
    ],
  },
  {
    path: "*",
    publicOnly: true,
    // layout: Topmenu,
    routes: [
      {
        exact: true,
        path: "/",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/tarif_des_notaires",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/categorie/:url_name",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/moncompte",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/favoris",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/categorie/:url_name/simulateur/:simulateur",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/categorie/:url_name/dmtg/:simulateur",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/categorie/:url_name/others/:simulateur",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/avis",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/fiches",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/pratique",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/pratiques",
        component: RedirectToLogin,
      },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_immo",
      //   component: FichesImmo,
      // },
      {
        exact: true,
        layout: Topmenu,
        layoutHeader: Header,
        layoutSectionNavigation: SectionNavigation,
        path: "/passwordForgot",
        component: ForgotPassword,
      },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_famille",
      //   component: FichesFamille,
      // },
      // {
      //   exact: true,
      //   path: "/fiches/fiches_generales",
      //   component: FichesGenerales,
      // },
      // {
      //   exact: true,
      //   path: "/rappels",
      //   component: Rappels,
      //   layoutInfoFooter: InfosFooter,
      //   layoutFooter: Footer,
      // },
      {
        exact: true,
        path: "/SchemaFiscalite",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/AnalysePatrimoniale/ProcessPatrimoine/:id",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/AnalysePatrimoniale",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/FramedPDF/:url",
        component: RedirectToLogin,
      },
      {
        exact: true,
        path: "/loyia",
        component: RedirectToLogin,
      },
      // {
      //     component: () => <Redirect to="/404" />
      // }
    ],
  },
];
function checkJWT() {
  if (localStorage.getItem("user")) {
    try {
      const userInStorage = JSON.parse(localStorage.getItem("user"))?.jwt;
      if (userInStorage === undefined) {
        return false;
      }
      let decodedToken = jwt_decode(userInStorage);
      let currentDate = new Date();
      // JWT exp is in seconds
      if (decodedToken.exp * 1000 - 86400 < currentDate.getTime()) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  return false;
}
const renderRoutes = (routes) =>
  routes ? (
    //<Suspense
    // fallback={<LoadingScreen/>}
    //>
    <Route>
      {routes.map((route, i) => {
        if (route.authOnly && !checkJWT()) {
          return null;
        }
        if (route.publicOnly && checkJWT()) {
          return null;
        }

        const Layout = route.layout || EmptyRouteSlot;
        const LayoutFooter = route.layoutFooter || EmptyRouteSlot;
        const LayoutHeader = route.layoutHeader || EmptyRouteSlot;
        const LayoutInfoFooter = route.layoutInfoFooter || EmptyRouteSlot;
        const LayoutBreadCrumb = route.layoutBreadCrumb || EmptyRouteSlot;
        const LayoutSectionNavigation = route.layoutSectionNavigation || EmptyRouteSlot;
        const Component = route.component || EmptyRouteSlot;
        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <>
                <Layout />
                <LayoutHeader />
                <LayoutSectionNavigation />
                <EssentielTracker />
                <LayoutBreadCrumb />
                <>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </>
                <LayoutInfoFooter />
                <LayoutFooter />
              </>
            )}
          />
        );
      })}
    </Route>
  ) : //</Suspense>
  null;
// Routes are rendered without a <Switch>, so a catch-all route would show on
// every page. Instead, check whether any leaf route (visible for the current
// auth state) matches the URL, and render NotFound if none does.
const isKnownPath = (routes, pathname) =>
  routes.some((route) => {
    if (route.authOnly && !checkJWT()) {
      return false;
    }
    if (route.publicOnly && checkJWT()) {
      return false;
    }
    if (!matchPath(pathname, { path: route.path, exact: route.exact })) {
      return false;
    }
    return route.routes ? isKnownPath(route.routes, pathname) : true;
  });

function RenderRoutes() {
  const { pathname } = useLocation();
  if (!isKnownPath(routesConfig, pathname)) {
    return <NotFound />;
  }
  return renderRoutes(routesConfig);
}
export default RenderRoutes;
